import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import TwoColumn from '../../components/TwoColumn';
import Layout from './Layout';
import Request from './Request';

import './styles.css';

export default function Leave() {
  const location = useLocation();

  const active = React.useMemo(() => (location.pathname !== '/leave'), [location]);

  return (
    <TwoColumn right={active}>
      <TwoColumn.Left>
        <Layout />
      </TwoColumn.Left>
      <TwoColumn.Right>
        <Routes>
          <Route path="request" element={<Request />} />
        </Routes>
      </TwoColumn.Right>
    </TwoColumn>
  );
}
